import { render } from "./BulkReportMOExport.vue?vue&type=template&id=3196f6a6"
import script from "./BulkReportMOExport.vue?vue&type=script&lang=ts"
export * from "./BulkReportMOExport.vue?vue&type=script&lang=ts"
script.render = render

export default script